export default "__VITE_ASSET__D6Ql8wbF__"